import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from "redux-form";
import {renderTextField} from "./inputs/TextFeaild";

export class UserForm extends React.Component {

    render() {

        const {handleSubmit, errors} = this.props;

        return (
            <form onSubmit={handleSubmit}>

                <Field name="email"
                       label="メールアドレス"
                       err={errors.email}
                       component={renderTextField}
                       type="text"/>

                <Field name="password"
                       label="パスワード"
                       err={errors.password}
                       component={renderTextField}
                       type="password"/>

                <Field name="name"
                       label="氏名"
                       err={errors.name}
                       component={renderTextField}
                       type="text"/>

            </form>
        )
    }
}

UserForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
};

UserForm = reduxForm({
    form: 'user'
})(UserForm);


// WEBPACK FOOTER //
// ./src/forms/user.js